export default "assets/images/icons/tiktok-8e995cf0.svg";